import { render, staticRenderFns } from "./AsdaBenefits.vue?vue&type=template&id=0b420cc6"
import script from "./AsdaBenefits.vue?vue&type=script&lang=js"
export * from "./AsdaBenefits.vue?vue&type=script&lang=js"
import style0 from "./AsdaBenefits.vue?vue&type=style&index=0&id=0b420cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports